import { Routes, Route } from "react-router-dom";

import {
  SidebarContentOuterContainer,
  SidebarContentInnerContainer,
} from "@app/analytics/components/reports/styles";
import useSessionMetadata from "@app/analytics/MeetingReport/hooks/useSessionMetadata";
import { useMeetingReportContext } from "@app/analytics/MeetingReport/providers/MeetingReportContext";

import DeepDiveChart from "./DeepDiveChart";
import HighlightsAndChapters from "./HighlightsAndChapters";
import SidebarTranscript from "./SidebarTranscript";

const MeetingReportSidebarContent = () => {
  const {
    data: { metricsLevel },
  } = useSessionMetadata();
  const { sidebarScrollContainer } = useMeetingReportContext();

  return (
    <SidebarContentOuterContainer zIndex={2} flexGrow={1} marginTop={1.5}>
      <SidebarContentInnerContainer ref={sidebarScrollContainer} flexGrow={1}>
        <Routes>
          {/* NOTE: don't need a fallback route here since redirecting away from any non-existent
          routes/tabs is handled in the MeetingReportContent component */}
          <Route index element={<HighlightsAndChapters />} />
          {metricsLevel !== "objective_metrics" && (
            <Route path="deep-dive" element={<DeepDiveChart />} />
          )}
          <Route path="coaching" element={<SidebarTranscript />} />
        </Routes>
      </SidebarContentInnerContainer>
    </SidebarContentOuterContainer>
  );
};

export default MeetingReportSidebarContent;
